<template>
    <StandardDropdown
        :modelValue="selectedClientDisplay()"
        :options="clientOptions"
        placeholder="Select Client"
        class="multiselect-custom"
        @change="selectClient($event.value)"
        id="client-selector"
    />
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';

export default {
    name: 'ClientSelector',
    props: ['selectedClient', 'clientOptions'],
    components: {
        StandardDropdown,
    },
    methods: {
        selectClient(value) {
            this.$emit('handleSelectedClient', value);
        },
        selectedClientDisplay() {
            if (this.selectedClient) {
                return { name: this.selectedClient['name'], uuid: this.selectedClient['uuid'] };
            }
        },
    },
};
</script>
